import { Link } from 'react-router-dom'
import { SiteContentLayout } from '../components/SiteContentLayout'
import { LOCATIONS_PAGE } from '../constants/locations-page'

export function LocationsPage() {
  return (
    <SiteContentLayout
      eyebrow={LOCATIONS_PAGE.eyebrow}
      title={LOCATIONS_PAGE.title}
      lead={LOCATIONS_PAGE.lead}
    >
      <section className="content-page__section">
        <h2>{LOCATIONS_PAGE.serveTitle}</h2>
        <div className="content-page__offer-grid">
          {LOCATIONS_PAGE.regions.map((region) => (
            <article key={region.name} className="content-page__card">
              <h3>{region.name}</h3>
              <ul className="content-page__list">
                {region.cities.map((city) => (
                  <li key={city}>{city}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
        <p className="content-page__note">{LOCATIONS_PAGE.missingCity}</p>
      </section>

      <section className="content-page__section">
        <h2>{LOCATIONS_PAGE.servicesTitle}</h2>
        <div className="content-page__offer-grid">
          {LOCATIONS_PAGE.services.map((group) => (
            <article key={group.title} className="content-page__card">
              <h3>{group.title}</h3>
              <ul className="content-page__list">
                {group.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section className="content-page__section">
        <h2>{LOCATIONS_PAGE.whyTitle}</h2>
        <ul className="content-page__chips">
          {LOCATIONS_PAGE.whyItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="content-page__card content-page__card--cta">
        <h2>{LOCATIONS_PAGE.ctaTitle}</h2>
        <p>{LOCATIONS_PAGE.tagline}</p>
        <Link className="content-page__cta" to={LOCATIONS_PAGE.ctaTo}>
          {LOCATIONS_PAGE.ctaLabel}
        </Link>
      </section>
    </SiteContentLayout>
  )
}
